import tseInstance from '../../instance'

const printYearOrder = (year) => {
  return tseInstance.post(`/nullOrders/years/${year}/print`)
}

export default printYearOrder